/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Trigger
 * @export
 * @interface Trigger
 */
export interface Trigger {
    /**
     * The time the trigger will be activated
     * @type {Date}
     * @memberof Trigger
     */
    activationTime?: Date;
    /**
     * Description of when the trigger is being activated
     * @type {string}
     * @memberof Trigger
     */
    displayTimeTable?: string;
}

/**
 * Check if a given object implements the Trigger interface.
 */
export function instanceOfTrigger(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TriggerFromJSON(json: any): Trigger {
    return TriggerFromJSONTyped(json, false);
}

export function TriggerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trigger {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activationTime': !exists(json, 'activationTime') ? undefined : (new Date(json['activationTime'])),
        'displayTimeTable': !exists(json, 'displayTimeTable') ? undefined : json['displayTimeTable'],
    };
}

export function TriggerToJSON(value?: Trigger | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activationTime': value.activationTime === undefined ? undefined : (value.activationTime.toISOString()),
        'displayTimeTable': value.displayTimeTable,
    };
}

